<template>
    <Teleport to="body">
        <TransitionRoot as="template" :show="modelValue">
            <Dialog class="relative z-[80]" @close="close">
                <TransitionChild
                    as="template"
                    enter="transition-opacity ease-linear duration-200"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="transition-opacity ease-linear duration-200"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                >
                    <div class="fixed inset-0 bg-slate-950/45 backdrop-blur-sm" />
                </TransitionChild>

                <div class="fixed inset-0 overflow-hidden">
                    <div class="absolute inset-0 overflow-hidden">
                        <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-8 sm:pl-12">
                            <TransitionChild
                                as="template"
                                enter="transform transition ease-in-out duration-300"
                                enter-from="translate-x-full"
                                enter-to="translate-x-0"
                                leave="transform transition ease-in-out duration-300"
                                leave-from="translate-x-0"
                                leave-to="translate-x-full"
                            >
                                <DialogPanel class="pointer-events-auto w-screen max-w-xl">
                                    <div class="flex h-full flex-col bg-white shadow-2xl">
                                        <div class="border-b border-slate-200 px-6 py-5">
                                            <div class="flex items-start justify-between gap-4">
                                                <div class="min-w-0">
                                                    <DialogTitle class="text-lg font-semibold text-slate-950">
                                                        {{ title }}
                                                    </DialogTitle>
                                                    <div v-if="$slots.subtitle" class="mt-1 text-sm text-slate-500">
                                                        <slot name="subtitle" />
                                                    </div>
                                                </div>

                                                <button
                                                    type="button"
                                                    class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-slate-500 transition hover:bg-slate-100 hover:text-slate-900"
                                                    :aria-label="closeLabel"
                                                    @click="close"
                                                >
                                                    <fa-icon icon="xmark" />
                                                </button>
                                            </div>
                                        </div>

                                        <div class="min-h-0 flex-1 overflow-y-auto px-6 py-5">
                                            <slot />
                                        </div>
                                    </div>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </div>
            </Dialog>
        </TransitionRoot>
    </Teleport>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'

defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    closeLabel: {
        type: String,
        required: true,
    },
})

const emit = defineEmits(['update:modelValue'])

const close = () => {
    emit('update:modelValue', false)
}
</script>
